import { tsUtils } from '@neo-one/ts-utils';
export const hasUndefined = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isUndefined(context, node, tpe));
export const isOnlyUndefined = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isUndefined(context, node, tpe));
export const isUndefined = (_context, _node, type) => tsUtils.type_.isUndefinedish(type);

//# sourceMappingURL=typeTests.js.map
